export default {
	'is': {
		'bin_title': 'Beygingarlýsing íslensks nútímamáls',
		'bin_about': 'Beygingarlýsingin er safn ríflega 300.000 beygingardæma með öllum beygingarmyndum hvers orðs.',
		'kata_title': 'Íslensk nútímamálsorðabók',
		'kata_about': 'Ný íslensk orðabók með um 50 þúsund flettum.',
		'stafsetning_title': 'Íslensk stafsetningarorðabók',
		'stafsetning_about': 'Áður <i>Stafsetningarorðabókin</i>. Opinber réttritunarorðabók um íslensku. Hlutverk hennar er að leiðbeina um rithátt og beygingar í samræmi við hefðbundin viðhorf um vandað ritmál. Byggt er á ritreglum Íslenskrar málnefndar.',
		'ordsifjabok_title': 'Íslensk orðsifjabók',
		'ordsifjabok_subtitle': '1989',
		'ordsifjabok_about': 'Í Íslenskri orðsifjabók eftir Ásgeir Blöndal Magnússon má finna skýringar um myndun og uppruna íslenskra orða. Hafa verður í huga að orðsifjabókin er höfundarverk Ásgeirs og efnið hefur ekki verið uppfært eða endurbætt í ljósi nýrra viðhorfa eftir að bókin kom út 1989.',
		'ordanet_title': 'Íslenskt orðanet',
		'ordanet_subtitle': 'Samheiti - orðasambönd - merkingartengsl',
		'ordanet_about': 'Íslenskt orðanet sýnir merkingartengsl íslenskra orða og orðasambanda. Það sameinar hlutverk samheita- og hugtakaorðabókar og kemur að hagnýtum notum við ritun og textagerð.',
		'ordabanki_title': 'Íðorðabankinn',
		'ordabanki_about': 'Orðabanki með skýringum og íslenskum þýðingum á hugtökum á meira en 60 sérsviðum. Unnið af sérfræðingum á viðkomandi sviðum.',
		'malfar_title': 'Málfarsbankinn',
		'malfar_about': 'Safn stuttra greina um málfarsleg atriði og svör við algengum spurningum um málfar.',
		'islex_title': 'ISLEX-orðabókin',
		'islex_about': 'ISLEX er margmála orðabók á vefnum. Grunnmálið er íslenska og markmálin eru danska, sænska, norskt bókmál, nýnorska, færeyska og finnska. ISLEX er samstarfsverkefni sex norrænna fræðastofnana, á Íslandi, í Danmörku, Noregi, Svíþjóð, Færeyjum og Finnlandi. ',
		'blondal_title': 'Íslensk-dönsk orðabók eftir Sigfús Blöndal',
		'blondal_subtitle': '1920–1924',
		'blondal_about': 'Íslensk-dönsk orðabók eftir Sigfús Blöndal kom út á árunum 1920−1924. Orðabókin er lykilverk í íslenskri orðabókarsögu og er hún ein stærsta íslenska orðabókin sem hefur verið gerð til þessa. Allar orðskýringar í bókinni eru á dönsku sem kann að vekja furðu nú um stundir, en á þeim árum sem verkið var í vinnslu (1903–1920) var Ísland enn hluti af Danmörku. Styrkir til starfsins og útgáfunnar komu frá dönskum sjóðum, svo og dönskum og íslenskum stjórnvöldum.',
		'nyyrdi_title': 'Nýyrðavefurinn',
		'nyyrdi_about': 'Á nýyrðavef Stofnunar Árna Magnússonar í íslenskum fræðum eru birt sýnishorn söfnunar undanfarinna ára en einnig er hægt að senda inn nýyrði.',
		'ritmalssafn_title': 'Ritmálssafn Orðabókar Háskólans',
		'ritmalssafn_subtitle': '16.–20. öld',
		'ritmalssafn_about': 'Í Ritmálssafninu eru dæmi um notkun orða úr íslenskum ritum. Þau spanna tímabilið frá miðri 16. öld til loka 20. aldar. ',
		'russneska_title': 'Íslenzk-rússnesk orðabók eftir Valeríj P. Bérkov',
		'russneska_about': 'Íslenzk-rússnesk orðabók er samin af Valéríj P. Bérkov með aðkomu Árna Böðvarssonar. Bókin kom út árið 1962 og er fyrir löngu uppseld.',
		'lexia_about': 'LEXÍA er veforðabók milli íslensku og frönsku, unnin í samstarfi Árnastofnunar og Stofnunar Vigdísar Finnbogadóttur í erlendum tungumálum.\nÍ undirbúningi er þýska sem annað markmál orðabókarinnar og verður hún opnuð síðar á heimasíðu LEXÍU.',

		'leita': 'Leita',
		'menu_back': 'Til baka',

		'rada_gagnasofnum': 'Raða gagnasöfnum',
		'rada_gagnasofnum_info': 'Hér getur þú raðað gagnasöfnunum eins og þér hentar.',
		'rada_gagnasofnum_lokid': 'Vista endurröðun',

		'database_display_in_results': 'Birta gagnasafn í leitarniðurstöðum',
		'database_hide_in_results': 'Fela gagnasafn í leitarniðurstöðum',

		'flokkur1_label': 'Nútímamál',
		'flokkur2_label': 'Eldri orðabækur',
		'flokkur3_label': 'Tvímála orðabækur',

		'notfount_part1': 'Flettan',
		'notfount_part2': 'fannst ekki í neinu gagnasafni',
		'found_part1': 'fannst í',
		'found_part2': 'gagnasafni',
		'found_part2_plural': 'gagnasöfnum',
		'beygingarmynd_part1': 'getur líka verið beygingarmynd af',
	},
	'en': {
		'bin_title': 'Beygingarlýsing íslensks nútímamáls – Database of Modern Icelandic Inflection',
		'bin_about': 'This is a collection of inflectional paradigms showing conjugations and declensions of individual Icelandic words.',
		'kata_title': 'Íslensk nútímamálsorðabók – A Dictionary of Contemporary Icelandic',
		'kata_about': 'A dictionary of modern Icelandic with around 50,000 entries.',
		'stafsetning_title': 'Íslensk stafsetningarorðabók – The Icelandic Spelling Dictionary',
		'stafsetning_about': 'The 2nd edition of the Dictionary of Orthography. Rules on spelling and grammar, reviewed in 2016, are linked to the dictionary entries and appear with search results. The dictionary is a work in progress.',
		'ordsifjabok_title': 'Íslensk orðsifjabók – Icelandic Etymological Dictionary',
		'ordsifjabok_about': 'The Etymological Dictionary of Icelandic by Ásgeir Blöndal Magnússon contains explanations of word formation and origins.',
		'ordanet_title': 'Íslenskt orðanet – Icelandic Wordnet',
		'ordanet_about': 'Icelandic Word Web maps the semantic relationship of Icelandic words and phrases. It serves as both a dictionary of synonyms and word combinations for practical use in writing and editing.',
		'ordabanki_title': 'Íðorðabankinn – Terminology Bank',
		'ordabanki_about': 'A terminology dictionary with explanations and Icelandic translations of terms in more than 60 special fields. Compiled by experts in the relevant fields.',
		'malfar_title': 'Málfarsbankinn – The Language Usage Database',
		'malfar_about': 'A collection of short articles on linguistic issues and answers to frequently asked questions about language use.',
		'islex_title': 'The ISLEX Project',
		'islex_about': 'ISLEX is an online multilingual dictionary between modern Icelandic and six Scandinavian target languages (TLs): Danish, Norwegian (both standards: Bokmål and Nynorsk), Swedish, Faroese and Finnish.',
		'blondal_title': 'Icelandic-Danish Dictionary, by Sigfús Blöndal',
		'blondal_subtitle': '1920–1924',
		'blondal_about': 'This Icelandic-Danish Dictionary, published in 1920−1924, is a milestone in the history of Icelandic lexicography.',
		'nyyrdi_title': 'Nýyrðavefurinn – Neologisms, coinages',
		'nyyrdi_about': 'A collection of recent neologisms and coinages suggested by members of the Icelandic speech community.',
		'ritmalssafn_title': 'Written Language Archive',
		'ritmalssafn_subtitle': '16.–20. öld',
		'ritmalssafn_about': 'The Written Language Archive contains examples of words and word use in Icelandic written sources such as books, periodicals etc from the middle of the 16th century to the end of the 20th century.',
		'russneska_title': 'Icelandic–Russian Dictionary',
		'russneska_about': 'Author: Valerij P. Bérkov, assisted by Árni Böðvarsson. Published in 1962 (has been out of print for a long time now). This electronic version of the dictionary is made in collaboration between the Árni Magnússon Institute for Icelandic Studies and Vigdís Finnbogadóttir Institute of Foreign Languages.',
		'lexia_title': 'LEXIA',
		'lexia_about': 'LEXIA is an Icelandic-French dictionary project, in collaboration between The Árni Magnússon Institute for Icelandic Studies ant the Vigdís Finnbogadóttir Institute of Foreign Languages. A number of German translations and equivalents can also be found.',

		'leita': 'Search',
		'menu_back': 'Go back',

		'rada_gagnasofnum': 'Arrange datasets',
		'rada_gagnasofnum_info': 'Here you can arrange the datasets based on your own needs.',
		'rada_gagnasofnum_lokid': 'Done',

		'database_display_in_results': 'Birta gagnasafn í leitarniðurstöðum',
		'database_hide_in_results': 'Fela gagnasafn í leitarniðurstöðum',

		'flokkur1_label': 'Contemporary Icelandic',
		'flokkur2_label': 'Older Sources',
		'flokkur3_label': 'Bilingual Dictionaries',

		'notfount_part1': ' ',
		'notfount_part2': 'not found in any database',
		'found_part1': 'found in',
		'found_part2': 'database',
		'found_part2_plural': 'databases',
		'beygingarmynd_part1': 'can also belong to the lemma',
	}
}



// WEBPACK FOOTER //
// ./src/lang/langData.js